import React, { useEffect, useRef } from "react";

const HtmlZoomModal = ({ id, title = "Zoomed View", elementId }) => {
  const zoomContainerRef = useRef();

  useEffect(() => {
    const modal = document.getElementById(id);
    if (!modal) return;

    const handleModalShown = () => {
      const sourceElement = document.getElementById(elementId);
      if (sourceElement && zoomContainerRef.current) {
        zoomContainerRef.current.innerHTML = sourceElement.outerHTML;
        const inner = zoomContainerRef.current.querySelector(`#${elementId}`);
        if (inner) {
          inner.style.width = "100%";
          inner.style.height = "100%";
          inner.style.overflow = "hidden";
        }
      }
    };

    modal.addEventListener("shown.bs.modal", handleModalShown);
    return () => modal.removeEventListener("shown.bs.modal", handleModalShown);
  }, [id, elementId]);

  return (
    <div className="modal fade" id={id} tabIndex="-1" aria-hidden="true">
      <div
        className="modal-dialog modal-fullscreen"
        style={{ margin: 0, padding: 0 }}
      >
        <div
          className="modal-content border-0"
          style={{
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <div
            className="modal-header border-0"
            style={{
              background: "#f8f9fa",
              borderBottom: "1px solid #dee2e6",
              padding: "12px 20px",
              flexShrink: 0,
            }}
          >
            <h5 className="modal-title mb-0 fw-semibold">{title}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          {/* Body (Fullscreen Content) */}
          <div
            className="modal-body p-0 d-flex justify-content-center align-items-center"
            style={{
              width: "100%",
              height: "100%",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <div
              ref={zoomContainerRef}
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HtmlZoomModal;
